<template>
    <v-container>
        <h1>Dashboard</h1>
        <v-row justify='center' class='mt-15'>
            <v-col lg=8 >
                 <v-img
                        :src="require('../assets/under_construction.svg')"
                        
                        contain
    
        />
            <h2 class='text-center mt-10 font-weight-regular'> Coming Soon!</h2>
            </v-col>
           
        </v-row>
        
    </v-container>
</template>
<script>
export default {
    name:'Dashboard',
    created()
    {
        this.$emit('showLogout',true);
        this.$emit('showNavDrawer',true);
    }
}
</script>